// extracted by mini-css-extract-plugin
export default {"item":"Q0hVVroX6_","link":"JodEco7IHe","more":"Jb0GyUkJkh"};